"use client";

import {
  MenubarRadioGroup,
  MenubarRadioItem,
  MenubarSub,
  MenubarSubContent,
  MenubarSubTrigger,
} from "@oreme/ui";
import { useLocale, useTranslations } from "next-intl";
import { setUserLocale } from "@/i18n/locale";
import type { Locale } from "@/i18n/config";

function SharedMenubarSettingsLocale() {
  const t = useTranslations("global.MenubarSettingsLocale");
  const locale = useLocale();

  const handleValueChange = async (value: string): Promise<void> => {
    await setUserLocale(value as Locale);
  };

  return (
    <MenubarSub>
      <MenubarSubTrigger>{t("title")}</MenubarSubTrigger>
      <MenubarSubContent>
        <MenubarRadioGroup value={locale} onValueChange={handleValueChange}>
          <MenubarRadioItem value="fr">{t("french")}</MenubarRadioItem>
          <MenubarRadioItem value="en">{t("english")}</MenubarRadioItem>
        </MenubarRadioGroup>
      </MenubarSubContent>
    </MenubarSub>
  );
}

export { SharedMenubarSettingsLocale };
